export interface EditUserProps {
  children: React.ReactNode;
}

export function EditUser({ children }: EditUserProps) {
  return (
    <div className="bg-soFresh-100 relative size-full flex-col">{children}</div>
  );
}
